export enum PosReportsBackendAcceptableParams {
	STATUS = "STATUS",
	ID = "ID",
	OPENED_AT = "OPENED_AT",
	CLOSED_AT = "CLOSED_AT",
	TYPE = "TYPE",
	TERMINAL = "TERMINAL",
	DESCRIPTION = "DESCRIPTION",
	INCOME_AMOUNT = "INCOME_AMOUNT",
}

export enum PosReportCardType {
	BASIC = "BASIC",
	TRANSACTIONS = "TRANSACTIONS",
	PAIDS = "PAIDS",
	PAYMENT_METHODS = "PAYMENT_METHODS",
	DISCOUNTS = "DISCOUNTS",
	EMPLOYEES = "EMPLOYEES",
	DELIVERY_EMPLOYEES = "DELIVERY_EMPLOYEES",
	ORDER_SOURCES = "ORDER_SOURCES",
}
